"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REAGAN_MAJOR_VERSION = void 0;
var REAGAN_MAJOR_VERSION = 7;
exports.REAGAN_MAJOR_VERSION = REAGAN_MAJOR_VERSION;